import { useContext, useEffect, useMemo, useState } from "react";
import { DefaultContext } from "../../../../contexts/default";
import { useFormik } from "formik";
import StoreDB from "../../../../database/wrappers/store";
import Dropdown, { DropdownMenu, DropdownToggle } from "../../../../components/bootstrap/Dropdown";
import Button from "../../../../components/bootstrap/Button";
import Label from "../../../../components/bootstrap/forms/Label";
import Select from "../../../../components/bootstrap/forms/Select";
import FormGroup from "../../../../components/bootstrap/forms/FormGroup";
import useDarkMode from "../../../../hooks/useDarkMode";
import { orderBy } from "firebase/firestore";
import { ACCESS_LEVEL } from "../../../../types/roles";

const years = [
  { value: '2025', text: '2025' },
  { value: '2026', text: '2026' },
];

const months = [
  { value: '01', text: 'Janeiro' },
  { value: '02', text: 'Fevereiro' },
  { value: '03', text: 'Março' },
  { value: '04', text: 'Abril' },
  { value: '05', text: 'Maio' },
  { value: '06', text: 'Junho' },
  { value: '07', text: 'Julho' },
  { value: '08', text: 'Agosto' },
  { value: '09', text: 'Setembro' },
  { value: '10', text: 'Outubro' },
  { value: '11', text: 'Novembro' },
  { value: '12', text: 'Dezembro' },
];

const FilterDre = ({ onChange }) => {
  const { themeStatus } = useDarkMode();
  const { accessLevel, establishments, estabSelected } = useContext(DefaultContext);
  const [storesInFilter, setStoresInFilter] = useState([]);
  const [filterMenu, setFilterMenu] = useState(false);

  const formik = useFormik({
    initialValues: {
      estab: estabSelected || '',
      store: '',
      month: '',
      year: '',
    },
    onSubmit: (values) => {
      if (!values.estab || !values.month || !values.year) return;

      const daysInMonth = new Date(Number(values.year), Number(values.month), 0).getDate();
      const filter = {
        estab: values.estab,
        store: values.store,
        month: values.month,
        year: values.year,
        firstDate: `${values.year}-${values.month}-01 00:00:00`,
        secondDate: `${values.year}-${values.month}-${daysInMonth} 23:59:59`,
      };
      onChange(filter);
      setFilterMenu(false);
    },
  });

  // 🔄 Carregar lojas do estabelecimento selecionado
  useEffect(() => {
    if (!formik.values.estab) return;
    const loadStores = async () => {
      const storeDb = new StoreDB(formik.values.estab);
      const datas = await storeDb.getAll(orderBy("name", "asc"));
      setStoresInFilter(datas);
    };
    loadStores();
  }, [formik.values.estab]);

  const optionsEstablishments = useMemo(
    () => establishments.map(item => ({ value: item.id, text: item.name })),
    [establishments]
  );

  const optionsStores = useMemo(
    () => storesInFilter.map(item => ({ value: item.id, text: item.name })),
    [storesInFilter]
  );

  return (
    <Dropdown isOpen={filterMenu} setIsOpen={setFilterMenu}>
      <DropdownToggle hasIcon={false}>
        <Button
          style={filterMenu ? { color: themeStatus === 'dark' ? 'black' : 'white' } : {}}
          className='text-dark'
          icon='Filter'
          color='warning'>
          Filtros
        </Button>
      </DropdownToggle>

      <DropdownMenu isAlignmentEnd size='lg' isCloseAfterLeave={false}>
        <div className='container py-2'>
          <form className='row g-3' onSubmit={formik.handleSubmit}>
            {(accessLevel === ACCESS_LEVEL.ADMIN || accessLevel === ACCESS_LEVEL.MANAGER) && (
              <div className='col-12'>
                <FormGroup>
                  <Label htmlFor='estab'>Estabelecimento</Label>
                  <Select
                    id='estab'
                    placeholder='Selecione o estabelecimento'
                    list={optionsEstablishments}
                    onChange={formik.handleChange}
                    value={formik.values.estab}
                  />
                </FormGroup>
              </div>
            )}

            <div className='col-12'>
              <FormGroup>
                <Label htmlFor='store'>Loja</Label>
                <Select
                  id='store'
                  placeholder='Selecione a loja'
                  list={optionsStores}
                  onChange={formik.handleChange}
                  value={formik.values.store}
                />
              </FormGroup>
            </div>

            <div className='col-6'>
              <FormGroup>
                <Label htmlFor='month'>Mês</Label>
                <Select
                  id='month'
                  placeholder='Selecione o mês'
                  list={months}
                  onChange={formik.handleChange}
                  value={formik.values.month}
                />
              </FormGroup>
            </div>

            <div className='col-6'>
              <FormGroup>
                <Label htmlFor='year'>Ano</Label>
                <Select
                  id='year'
                  placeholder='Selecione o ano'
                  list={years}
                  onChange={formik.handleChange}
                  value={formik.values.year}
                />
              </FormGroup>
            </div>

            <div className='col-6'>
              <Button
                className='w-100 text-dark bg-white'
                color='warning'
                isOutline
                onClick={formik.resetForm}>
                Resetar
              </Button>
            </div>

            <div className='col-6'>
              <Button
                style={{ color: 'black' }}
                color='warning'
                className='w-100'
                type='submit'>
                Filtrar
              </Button>
            </div>
          </form>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default FilterDre;
